export const defaultHomeContent = {
  heroTitle: "Run With Us!",
  heroSubtitleHtml:
    'Monday through Friday at 5:00 PM we meet under the <a href="https://www.google.com/maps/place/PP1,+College+Park,+MD+20740/@38.9933786,-76.9425631,148m/data=!3m2!1e3!4b1!4m2!3m1!1s0x89b7c69f4dc17645:0xd2d09f5ca7e6b0d9" class="band-link">School of Public Health overhang</a> for distance runners and Kehoe Track for sprinters.',
  ctas: [
    { label: "Join the Club", href: "/joinus", variant: "primary" },
    { label: "Meet The Officers", href: "/about", variant: "secondary" },
  ],
  pills: [
    { label: "300+ Terps", icon: "people" },
    { label: "NIRCA Meets", icon: "events" },
    { label: "Daily Practices", icon: "time" },
    { label: "Motion", icon: "motion" },
  ],
  sectionTitles: {
    topRoutes: "Top Routes Right Now",
    events: "Upcoming Events",
    recordsFall: "All-time Fall Performances",
    recordsSpring: "All-time Spring Performances",
  },
};
